
<div class="cart-wrapper">
	<slot />
</div>
